import styled from "styled-components";
import * as React from "react";
import InternalLink from "../link/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";

const UnstyledLink = styled(InternalLink)`
  all: unset;
  cursor: pointer;
`;

const CategoryHeading = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.mediumEmphasis};
`;

const CategoryDivider = styled.div`
  background-color: ${({ theme }) => theme.colors.awesome};
  height: 2px;
  width: 100%;
  margin-top: 10px;
`;

const Root = styled.div`
  width: 100%;
`;

const CategoryHeadingRoot = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
`;

const CategoryHeadingTitle = styled.div`
  flex-grow: 1;
`;

const LinksRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0px;
  overflow: hidden;
  transition: ${({ enableTransition }) =>
    enableTransition ? ` max-height linear 200ms` : "unset"};
`;

const Link = styled(UnstyledLink)`
  font-size: 14px;
`;

const CategoryHeadingLink = styled(UnstyledLink)`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.mediumEmphasis};
`;

const Button = styled.button`
  all: unset;
  background-color: transparent;
  cursor: pointer;
`;

const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

function DrawerCategory(props) {
  const { item, onClose } = props;
  const [maxHeight, setMaxHeight] = React.useState(0);
  const [enableTransition, setEnableTransition] = React.useState(false);
  const linksRef = React.useRef(null);

  const onExpansionHandler = () => {
    setMaxHeight((maxHeight) => {
      if (maxHeight === 0) {
        return linksRef.current.scrollHeight;
      } else {
        return 0;
      }
    });
  };

  React.useLayoutEffect(() => {
    setMaxHeight(linksRef.current.scrollHeight);
  }, []);

  React.useEffect(() => {
    setEnableTransition(true);
  }, []);

  return (
    <Root data-component-name="drawer-category">
      <CategoryHeadingRoot>
        <CategoryHeadingTitle>
          {item.url !== undefined ? (
            <CategoryHeadingLink onClick={onClose} url={item.url}>
              {item.text}
            </CategoryHeadingLink>
          ) : (
            <CategoryHeading>{item.text}</CategoryHeading>
          )}
          <CategoryDivider />
        </CategoryHeadingTitle>
        <Button onClick={onExpansionHandler} aria-label="Expansion Toggle">
          {maxHeight === 0 ? (
            <FontAwesomeIcon icon={faCaretUp} />
          ) : (
            <FontAwesomeIcon icon={faCaretDown} />
          )}
        </Button>
      </CategoryHeadingRoot>
      <LinksRoot
        ref={linksRef}
        style={{ maxHeight }}
        enableTransition={enableTransition}
      >
        <GroupContainer>
          {item.linkItems.map((group, idx) => (
            <Group key={idx}>
              {group.map((link) => (
                <Link key={link.text} url={link.url} onClick={onClose}>
                  {link.text}
                </Link>
              ))}
            </Group>
          ))}
        </GroupContainer>
      </LinksRoot>
    </Root>
  );
}

export default DrawerCategory;
